import script from "./SecondSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecondSection.vue?vue&type=script&setup=true&lang=ts"

import "./SecondSection.vue?vue&type=style&index=0&id=92ba9504&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92ba9504"]])

export default __exports__